import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GetInitTopModel } from '../vo/get-init-top.model';
 
@Injectable()
export class LoginUserInfoService {
  private LoginUserInfoSubject = new BehaviorSubject<GetInitTopModel | null>(null);
  loginUserInfo$: Observable<GetInitTopModel | null> = this.LoginUserInfoSubject.asObservable();
 
  // ログインユーザー情報設定
  setLoginUserInfo(loginUserInfo: GetInitTopModel): void {
    this.LoginUserInfoSubject.next(loginUserInfo);
  }
 
  // ログインユーザー情報リセット
  reset() {
    this.LoginUserInfoSubject.next(null);
  }
}